import { Typography } from "@mui/material";

const FieldErrorText = ({
  children
}) => {
  return (
    <Typography 
      variant="span"
      sx={{
        color: "red"
      }}
    >
      {children}
    </Typography>
  )
};

export default FieldErrorText;